import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { FacilityDialog } from 'src/modules/supply_chain/components/FacilityDialog'
import { skuit } from 'src/services/skuit'

import { FacilityListTable } from 'src/components/Table/list/Facility'
import { ListPage } from 'src/components/Pages/ListPage'

export const FacilityListPage = () => {
  const paginator = useQueryPaginator(
    'facility-list',
    skuit.sc.facilities.list
  )

  const exportFields = [
    "address1",
    "address2",
    "city",
    "guid",
    "name",
    "postal_code",
    "state",
  ]

  return (
    <ListPage
      title='Facilities'
      paginator={paginator}
      dialogs={[{ title: 'New Facility', Dialog: FacilityDialog }]}
    >
      <FacilityListTable
        paginator={paginator}
        fields={['name', 'market', 'address', 'phone']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.facilities.export
        }}
      />
    </ListPage>
  )
}
